import { VehicleRead } from 'src/common/external/bambi-api/bambiApi';

export function getVehicleById(
  id: string,
  vehicles: VehicleRead[]
): VehicleRead {
  return vehicles.find((vehicle) => vehicle.id === id) as VehicleRead;
}
